import type { DecoBuildCtx } from "./define.ts";
import { shade, rand } from "../color.ts";

// Two posts with a line and hanging cloths — cottage yard set-dressing.
const build: (ctx: DecoBuildCtx) => void = ({ box, rod, seed }) => {
  const wood = shade(0x6b4a2b, (rand(seed) - 0.5) * 0.1);
  const cloths = [0xe8e2d0, 0x7a4a6a, 0x6a7a54, 0xc4a574];
  box(-1.2, 0.9, 0, 0.12, 1.8, 0.12, wood);
  box(1.2, 0.9, 0, 0.12, 1.8, 0.12, wood);
  rod(-1.15, 1.65, 0, 1.15, 1.65, 0, 0.02, shade(wood, 0.2));
  for (let i = 0; i < 3; i++) {
    const x = -0.7 + i * 0.7;
    const c = cloths[(i + Math.floor(rand(seed + i) * 3)) % cloths.length]!;
    const h = 0.55 + rand(seed + 10 + i) * 0.25;
    const w = 0.35 + rand(seed + 20 + i) * 0.12;
    box(x, 1.65 - h / 2 - 0.05, 0.02, w, h, 0.04, shade(c, (rand(seed + 30 + i) - 0.5) * 0.08));
  }
};

export default build;
